import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { api } from "@/services/api";
import ScenarioCard from "@/components/ScenarioCard";

export default function Scenarios() {
  const navigate = useNavigate();
  const { data: scenarios = [], isLoading } = useQuery({ queryKey: ["scenarios"], queryFn: api.getScenarios });

  const startScenario = async (scenarioId) => {
    const session = await api.createSession(scenarioId);
    navigate(`/lesson/${scenarioId}?session=${session.id}`);
  };

  return (
    <div className="mx-auto max-w-7xl px-4 py-8 sm:px-6 lg:px-8" data-testid="scenarios-page">
      <section className="page-title-row" data-testid="scenarios-title-section">
        <p className="section-kicker" data-testid="scenarios-page-kicker">biblioteca inicial</p>
        <h1 className="font-display text-4xl font-black sm:text-5xl lg:text-6xl" data-testid="scenarios-page-heading">Situações reais nos EUA</h1>
        <p className="max-w-3xl text-base font-semibold text-slate-600 md:text-lg" data-testid="scenarios-page-description">
          Escolha uma cena e treine como se estivesse no balcão, no aeroporto, no trabalho ou resolvendo tarefas do dia a dia.
        </p>
      </section>
      {isLoading ? (
        <div className="neo-card surface-neutral mt-8 p-6" data-testid="all-scenarios-loading-state">Carregando biblioteca...</div>
      ) : (
        <section className="mt-8 grid gap-6 md:grid-cols-2 xl:grid-cols-3" data-testid="all-scenarios-grid">
          {scenarios.map((scenario, index) => (
            <ScenarioCard key={scenario.id} scenario={scenario} onStart={startScenario} index={index} />
          ))}
        </section>
      )}
    </div>
  );
}